export default __webpack_public_path__ + "static/media/stop.bd7d1ff7.svg";